import http from './request'

// 任务列表
export const refEarnTaskList = (data) => {
  return http({
    url: '/advertCenter/Order/getTaskList',
    method: 'post',
    data
  })
}

// 新手任务
export const refEarnGuideTask = (data) => {
  return http({
    url: '/user/advert/task/guide',
    method: 'post',
    data
  })
}

// 领取新手任务
export const grabRefEarnGuideTask = (data) => {
  return http({
    url: '/advertCenter/Task/receiveNewHandTask',
    method: 'post',
    data
  })
}

// 领取普通任务
export const grabRefEarnTask = (data) => {
  return http({
    url: '/user/advert/task/list',
    method: 'post',
    data
  })
}

// 完成任务
export const completeRefEarnTask = (data) => {
  return http({
    url: '/user/advert/completeTask',
    method: 'post',
    data
  })
}

// 领取奖励
export const claimRefEarnReward = (data) => {
  return http({
    url: '/user/advert/task/review',
    method: 'post',
    data
  })
}

// 下级列表
export const getSubUserList = (data) => {
  return http({
    url: '/promotion/SubUserStat/getPagedList',
    method: 'post',
    data
  })
}

// 获取职位汇总信息
export const getUserPositionInfo = (data) => {
  return http({
    url: '/promotion/UserPosition/getInfo',
    method: 'post',
    data
  })
}

// 获取邀请人数和总佣金
export const getRefEarnAgentInfo = (data) => {
  return http({
    url: '/promotion/ReferralEarnActivityAgent/getInfo',
    method: 'post',
    data
  })
}

// 获取裂变任务裂变
export const getRefEarnAgentTasks = (data) => {
  return http({
    url: '/promotion/ReferralEarnActivityAgent/getTasks',
    method: 'post',
    data
  })
}

// 升级弹窗
export const getUpgradeInfo = (data) => {
  return http({
    url: '/promotion/DialogInfo/getInfo',
    method: 'post',
    data
  })
}
